import React, { useState, useEffect } from "react";
import { ReactComponent as Github } from "../assets/icons/github.svg";
import { ReactComponent as LinkIcon } from "../assets/icons/link.svg";
import { useViewportScroll, motion } from "framer-motion";

const projects = [
  {
    id: 0,
    name: "Drishti",
    description: "The Smart Application for Blind Assistance.",
    image: "drishti",
    isPublic: true,
    github: "https://github.com/Sagarnaikg/drishti",
    isWeb: false,
  },
  {
    id: 1,
    name: "Hyperswitch",
    description: "Unified payments operations dashboard.",
    image: "hyperswitch",
    isPublic: true,
    github: "https://github.com/juspay/hyperswitch-control-center",
    isWeb: true,
    link: "https://app.hyperswitch.io/dashboard/register",
  },
  {
    id: 2,
    name: "Heart-care",
    description: "Heart rate monitor simulator app",
    image: "heartcare",
    isPublic: true,
    github: "https://github.com/Sagarnaikg/Heart-Care",
    isWeb: false,
  },
  {
    id: 3,
    name: "Dimiri-Marco",
    description: "Dimiri Marco personal website built using HTML and CSS .",
    image: "dimiri",
    isPublic: true,
    isWeb: true,
    github: "https://github.com/Sagarnaikg/Dimiri-Marco-Portfolio",
    link: "https://sagarnaikg.github.io/Dimiri-Marco-Portfolio/",
  },
  {
    id: 4,
    name: "Agency",
    description: "Animated landing page using react and gsap libraries.",
    image: "agency",
    isPublic: true,
    isWeb: true,
    github: "https://github.com/Sagarnaikg/Agency",
    link: "https://sagarnaikg.github.io/Agency/",
  },

  {
    id: 5,
    name: "Need-For-Blood",
    description:
      "A application which connect blood donors and recipients \
    through a system accessible on any device.",
    image: "needforblood",
    isPublic: true,
    isWeb: true,
    github: "https://github.com/Sagarnaikg/Need-For-Blood",
    link: "https://need-for-blood-9cf11.web.app/",
  },
];

const Project = () => {
  const disableWidth = 880;
  const scrollFactor1 = 1600;
  const scrollFactor2 = 300;
  const { scrollYProgress } = useViewportScroll();

  const [y1, setY1] = useState(0);
  const [y2, setY2] = useState(0);

  useEffect(() => {
    if (window.screen.width > disableWidth) {
      window.addEventListener("scroll", () => {
        setY1(scrollYProgress.get() * scrollFactor1);
        setY2(scrollYProgress.get() * scrollFactor2);
      });
    }
  }, []);

  return (
    <div className="project">
      <div className="container">
        <div className="project-subtitle subtitle">SELECTED WORKS</div>
        <div className="project-list">
          {projects.map((project, i) => (
            <motion.div
              style={
                window.screen.width < disableWidth
                  ? {}
                  : i % 2 === 0
                  ? { y: -y1 + 1000 }
                  : { y: -y2 + 200 }
              }
              className="project-item"
              key={project.id}
            >
              <div className="project-image">
                <motion.div
                  initial={
                    window.screen.width < disableWidth ? { y: 0 } : { y: 100 }
                  }
                  whileInView={{ y: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 1,
                    delay: 0,
                    ease: "easeOut",
                  }}
                >
                  <img
                    src={require(`../assets/images/${project.image}.png`)}
                    alt="img"
                  />
                </motion.div>
              </div>
              <div className="project-content">
                <div className="project-title">
                  {project.name.split("").map((letter, index) => (
                    <motion.div
                      className="letter"
                      initial={
                        window.screen.width < disableWidth
                          ? { y: 0 }
                          : { y: 35 }
                      }
                      whileInView={{ y: 0 }}
                      viewport={{ once: true }}
                      transition={{
                        duration: 0.6,
                        delay: index / 25,
                        ease: "easeOut",
                      }}
                    >
                      {letter}
                    </motion.div>
                  ))}
                </div>
                <div className="project-description">
                  <motion.div
                    initial={
                      window.screen.width < disableWidth
                        ? { opacity: 1 }
                        : { opacity: 0 }
                    }
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{
                      duration: 1.5,
                      delay: project.name.length / 20,
                      ease: "easeOut",
                    }}
                  >
                    {project.description}
                  </motion.div>
                </div>
                <div className="project-external-links">
                  <motion.div
                    whileHover={{ scale: 1.3 }}
                    initial={
                      window.screen.width < disableWidth
                        ? { opacity: 1 }
                        : { opacity: 0 }
                    }
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{
                      duration: 1.5,
                      delay: project.name.length / 20,
                      ease: "easeOut",
                    }}
                  >
                    {project.isPublic && (
                      <motion.div
                        whileHover={{ scale: 1.3 }}
                        transition={{
                          duration: 0.2,
                        }}
                        className="github"
                      >
                        <a href={project.github} target={"_blank"}>
                          <Github />
                        </a>
                      </motion.div>
                    )}
                  </motion.div>
                  <motion.div
                    initial={
                      window.screen.width < disableWidth
                        ? { opacity: 1 }
                        : { opacity: 0 }
                    }
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{
                      duration: 1.5,
                      delay: project.name.length / 20,
                      ease: "easeOut",
                    }}
                  >
                    {project.isWeb && (
                      <motion.div
                        whileHover={{ scale: 1.3 }}
                        transition={{
                          duration: 0.2,
                        }}
                        className="weblink"
                      >
                        <a href={project.link} target={"_blank"}>
                          <LinkIcon />
                        </a>
                      </motion.div>
                    )}
                  </motion.div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Project;
